module.exports = __webpack_public_path__ + "static/media/png.d100b539.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/png.png
// module id = 238
// module chunks = 0